import React from 'react'
import { graphql } from 'gatsby'
import Container from '../components/container'
import GraphQLErrorList from '../components/graphql-error-list'
import ProjectPreviewGrid from '../components/project/project-preview-grid'
import UseCasePreviewGrid from '../components/usecase/usecase-preview-grid'
import SEO from '../components/seo'
import Layout from '../containers/layout'
import { mapEdgesToNodes, filterOutDocsWithoutSlugs, buildImageObj } from '../lib/helpers'
import UspPreviewGrid from '../components/usp/usp-preview-grid'
import PageIntro from '../components/page/page-intro2'
import { PropTypes } from 'prop-types'
import ContactDemoButton from '../components/contact/ContactDemoButton'
import * as styles from '../styles/pages.module.css'
import { imageUrlFor } from '../lib/image-url'
import BlockTextDeckard from '../components/block-content/block-text-deckard'

export const query = graphql`query solutionsQuery {
  landing: allSanityLanding(filter: {slug: {current: {eq: "solution"}}}) {
    edges {
      node {
        mainImage {
          asset {
            _id
          }
          alt
        }
      }
    }
  }
  index: sanityLanding(slug: {current: {eq: "solution"}}, mainImage: {asset: {}}) {
    id
    _id
    title
    excerpt
    subtitle
    _rawBullets
    mainImage {
      alt
      asset {
        _id
      }
    }
    _rawBody
    usps {
      title
      subTitle
      _rawExcerpt
      _rawBullets
      linkText
      linkUrl
      style {
        color
      }
      mainImage {
        alt
        asset {
          _id
        }
      }
    }
    pageentries {
      id
      title
      excerpt
      slug {
        current
      }
    }
    usecases {
      id
      mainImage {
        asset {
          _id
        }
        alt
      }
      title
      excerpt
      slug {
        current
      }
    }
  }
  projects: allSanityProject(limit: 12, sort: {publishedAt: DESC}) {
    edges {
      node {
        id
        mainImage {
          asset {
            _id
          }
          alt
        }
        title
        _rawExcerpt
        slug {
          current
        }
      }
    }
  }
}`
const SolutionsPage = (props) => {
  const { data, errors } = props
  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }
  const useCaseEntries = (data || {}).index.usecases

  const bullets = data?.index._rawBullets
  const projectNodes =
    data &&
    data.projects &&
    mapEdgesToNodes(data.projects).filter(filterOutDocsWithoutSlugs)
  const useCasesNodes =
    data &&
    data.useCases &&
    mapEdgesToNodes(data.useCases).filter(filterOutDocsWithoutSlugs)
  const landingContent =
    data &&
    data.landing &&
    mapEdgesToNodes(data.landing).filter(filterOutDocsWithoutSlugs)
  const pageNodes = data?.index?.pageentries
  const index = data?.index
  const uspNodes = data?.index?.usps
  const firstUsp = uspNodes?.slice(0, 2)
  const secondUsp = uspNodes?.slice(2)
  return (

    <Layout backgroundColor='#EEF6F8'
    >
      <SEO title='Solution' />

      <PageIntro
        title={index.title}
        excerpt={index.excerpt}
        subtitle={index.subtitle}
        showExcerpt={true}
        sansFont={true}
        backgroundImage={index.mainImage}
        product={true}
        backgroundColor='#EEF6F8'
      />
      <Container>
        <ContactDemoButton />
        {firstUsp && firstUsp.length > 0 && <UspPreviewGrid nodes={firstUsp} />}
      </Container>
      <Container wide={true} textColor='#1A1A1A' >
        <div style={{marginTop:'4rem'}}className={styles.grid3columns}>
          {bullets.map((b,i) => (
            <div key={i} className={styles.sellingPoints}>
              <div className={styles.sellingImage}>
                <img
                  src={imageUrlFor(buildImageObj(b.image))
                    .height(180)
                    .url()}
                  alt="hei"
                />
              </div>
              <div className={styles.centered}>
                <BlockTextDeckard blocks={b.bulletText} />
              </div>
            </div>
          ))}
        </div>
      </Container>
      <Container>
        {secondUsp && secondUsp.length > 0 && <UspPreviewGrid nodes={secondUsp} />}
      </Container>
      {useCaseEntries && useCaseEntries.length > 0 && (
        <Container backgroundColor='#EBF5F4' fullwidth={true}>

          <UseCasePreviewGrid title='Solutions' nodes={useCaseEntries} />

        </Container>
      )}
      <Container>
        {pageNodes && pageNodes.length > 0 && (
          <PagePreviewGrid title='' itemColor='white' pages={pageNodes} />
        )}
      </Container>
    </Layout>
  )
}
SolutionsPage.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.array,
}

export default SolutionsPage
